import Rollbar from 'rollbar';

const rollbar = new Rollbar({
  accessToken: 'bae2d23315be4902b695fced014de886',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.NODE_ENV,
});

export default rollbar;